import DropdownOption from '@/models/DropdownOption';

export default class DropdownOptionRepository {
    public static getAll() {
        return DropdownOption.query()
            .withAll()
            .get();
    }
}
